import React from 'react';
import styled, { css } from 'styled-components';
import palette from '../../lib/styles/palette';

import { standardPulleyDia } from '../../lib/data/pulley-data-new';
import { formatDisplayValue } from '../../lib/styles/perttierNumber';
import { plummerBlocks } from '../../lib/data/plummerBlock-data';

const PulleyEditor = ({ pulley, minPulleyDia, drivePulley, handleChange, handleApplicationSelect, handleDiaSelection, handleEditDrivePulley, onAddPulley, onRemovePulley }) => {

    const isDrive = pulley.application?.includes('Drive') ? true : false;



    return (
        <PulleyEditorBlock>
            {/* <Input name="id" value={pulley.id} onChange={handleChange} /> */}
            {isDrive ? (
                <Wrapper>
                    <Input name={`${pulley.id}_application`} value={pulley.application} readOnly />
                    <Input name={`${pulley.id}_pulleyTypeCategory`} value={pulley.pulleyTypeCategory} readOnly />
                    <Input name={`${pulley.id}_numberOfPulley`} value={pulley.numberOfPulley} readOnly />
                    <Input name={`${pulley.id}_resultantForce`} value={pulley.resultantForce} readOnly />
                    <Input name={`${pulley.id}_torque`} value={pulley.torque} readOnly />
                    <Input name={`${pulley.id}_eccentricFactor`} value={pulley.eccentricFactor} readOnly />
                    <Input name={`${pulley.id}_maxMoment`} value={formatDisplayValue(pulley.maxMoment)} readOnly />
                    <Input name={`${pulley.id}_brgDistance`} value={pulley.brgDistance} readOnly />
                    <Input name={`${pulley.id}_webDistance`} value={pulley.webDistance} readOnly />
                    <Input name={`${pulley.id}_momentArm`} value={pulley.momentArm} readOnly />
                    <Spacer />
                    <Input name={`${pulley.id}_hubDiaByStress`} value={formatDisplayValue(pulley.hubDiaByStress)} readOnly />
                    <Input name={`${pulley.id}_hubDiaByDeflection`} value={formatDisplayValue(pulley.hubDiaByDeflection)} readOnly />
                    {/* <Input name={`${pulley.id}_hubDiaSelected`} placeholder={`${pulley.hubDiaCalculated}`} value={pulley.hubDiaSelected} onChange={handleChange} required /> */}
                    {/* hub dia.를 다시 선택하지 않고 계산된 값을 그대로 사용하는 것으로 하자. 그렇게 하지 않을 경우 아래 라인을 주석처리하고 윗라인을 사용하면 된다. */}
                    <Input name={`${pulley.id}_hubDiaSelected`} value={formatDisplayValue(pulley.hubDiaSelected)} readOnly />
                    <Input name={`${pulley.id}_brgDiaCalculated`} value={formatDisplayValue(pulley.brgDiaCalculated)} readOnly />
                    <Input name={`${pulley.id}_brgDiaSelected`} value={pulley.brgDiaSelected} readOnly />
                    <Input name={`${pulley.id}_plummerBlockNumber`} value={pulley.plummerBlockNumber} readOnly />
                    <Input name={`${pulley.id}_plummerBlockWeight`} value={formatDisplayValue(pulley?.plummerBlockWeight)} readOnly />
                    <Input name={`${pulley.id}_brgNumber`} value={pulley.brgNumber} readOnly />
                    <Input name={`${pulley.id}_dynamicRating`} value={pulley.dynamicRating} readOnly />
                    <Input name={`${pulley.id}_lifeL10h`} value={pulley.lifeL10h} readOnly />
                    {/* <Input name={`${pulley.id}_pulleyTurningResistance`} value={pulley.pulleyTurningResistance} readOnly /> */}
                    {/* <Input name={`${pulley.id}_beltWrappingResistance`} value={pulley.beltWrappingResistance} readOnly /> */}
                    <Spacer />
                    <Input name={`${pulley.id}_minPulleyDia`} value={formatDisplayValue(pulley.minPulleyDia)} readOnly />
                    <Input name={`${pulley.id}_minDiaByBelt`} value={formatDisplayValue(pulley.minDiaByBelt)} readOnly />
                    <Input name={`${pulley.id}_minDiaByHubDia`} value={formatDisplayValue(pulley.minDiaByHubDia)} readOnly />
                    <Input name={`${pulley.id}_minDiaByShapeRatio`} value={formatDisplayValue(pulley.minDiaByShapeRatio)} readOnly />
                    <Input name={`${pulley.id}_diaSelected`} value={pulley.diaSelected} onClick={handleEditDrivePulley} readOnly />
                    <Input name={`${pulley.id}_laggingThick`} value={pulley.laggingThick} readOnly />
                    <Input name={`${pulley.id}_diaWithLagging`} value={formatDisplayValue(pulley.diaWithLagging)} readOnly />
                    <Input name={`${pulley.id}_RPM`} value={formatDisplayValue(pulley.RPM)} readOnly />
                    <Spacer />
                    <Input name={`${pulley.id}_weight`} value={formatDisplayValue(pulley.weight)} readOnly />
                    <Spacer />
                    <div>
                        <button onClick={onAddPulley}>+</button>
                        {/* <button onClick={() => onRemovePulley(pulley.id)}>-</button> */}
                    </div>
                </Wrapper>
            ) : (
                <SelectWrapper>
                    <Select name={`${pulley.id}_application`} value={pulley.application} onChange={handleApplicationSelect} required readOnly={isDrive}>
                        <option value="" selected disabled>Select...</option>
                        {/* <option value="Drive">Drive</option> */}
                        <option value="1st Snub">1st Snub</option>
                        <option value="2nd Snub">2nd Snub</option>
                        <option value="Bend">Bend</option>
                        <option value="Takeup">Takeup</option>
                        <option value="Tail">Tail</option>
                        <option value="HTBend">HTBend</option>
                        <option value="LTBend">LTBend</option>
                    </Select>
                    <Input name={`${pulley.id}_pulleyTypeCategory`} value={pulley.pulleyTypeCategory} readOnly />
                    <Input name={`${pulley.id}_numberOfPulley`} value={pulley.numberOfPulley} onChange={handleChange} required />
                    <Input name={`${pulley.id}_resultantForce`} value={pulley.resultantForce} onChange={handleChange} required />
                    {/* 드라이브 풀리가 아니면 readOnly로 설정 */}
                    <Input name={`${pulley.id}_torque`} value={pulley.torque} onChange={handleChange} readOnly />
                    <Input name={`${pulley.id}_eccentricFactor`} value={pulley.eccentricFactor} onChange={handleChange} required />
                    <Input name={`${pulley.id}_maxMoment`} value={formatDisplayValue(pulley.maxMoment)} readOnly />
                    <Input name={`${pulley.id}_brgDistance`} value={pulley.brgDistance} readOnly />
                    <Input name={`${pulley.id}_webDistance`} value={pulley.webDistance} readOnly />
                    <Input name={`${pulley.id}_momentArm`} value={pulley.momentArm} readOnly />
                    <Spacer />
                    <Input name={`${pulley.id}_hubDiaByStress`} value={formatDisplayValue(pulley.hubDiaByStress)} readOnly />
                    <Input name={`${pulley.id}_hubDiaByDeflection`} value={formatDisplayValue(pulley.hubDiaByDeflection)} readOnly />
                    {/* <Input name={`${pulley.id}_hubDiaSelected`} placeholder={`${pulley.hubDiaCalculated}`} value={pulley.hubDiaSelected} onChange={handleChange} required /> */}
                    {/* hub dia.를 다시 선택하지 않고 계산된 값을 그대로 사용하는 것으로 하자. 그렇게 하지 않을 경우 아래 라인을 주석처리하고 윗라인을 사용하면 된다. */}
                    <Input name={`${pulley.id}_hubDiaSelected`} value={formatDisplayValue(pulley.hubDiaSelected)} readOnly />
                    
                    <Input name={`${pulley.id}_brgDiaCalculated`} value={formatDisplayValue(pulley.brgDiaCalculated)} readOnly />
                    <Select name={`${pulley.id}_brgDiaSelected`} value={pulley.brgDiaSelected} onChange={handleChange} required>
                        <option value="" selected disabled>Select...</option>
                        {plummerBlocks.map(item => <option value={item.dia}>{item.dia}</option>)}
                    </Select>
                    <Input name={`${pulley.id}_plummerBlockNumber`} value={pulley.plummerBlockNumber} readOnly />
                    <Input name={`${pulley.id}_plummerBlockWeight`} value={formatDisplayValue(pulley?.plummerBlockWeight)} readOnly />
                    <Input name={`${pulley.id}_brgNumber`} value={pulley.brgNumber} readOnly />
                    <Input name={`${pulley.id}_dynamicRating`} value={pulley.dynamicRating} readOnly />
                    <Input name={`${pulley.id}_lifeL10h`} value={pulley.lifeL10h} readOnly />
                    {/* <Input name={`${pulley.id}_pulleyTurningResistance`} value={pulley.pulleyTurningResistance} readOnly /> */}
                    {/* <Input name={`${pulley.id}_beltWrappingResistance`} value={pulley.beltWrappingResistance} readOnly /> */}
                    <Spacer />
                    <Input name={`${pulley.id}_minPulleyDia`} value={formatDisplayValue(pulley.minPulleyDia)} readOnly />
                    <Input name={`${pulley.id}_minDiaByBelt`} value={formatDisplayValue(pulley.minDiaByBelt)} readOnly />
                    <Input name={`${pulley.id}_minDiaByHubDia`} value={formatDisplayValue(pulley.minDiaByHubDia)} readOnly />
                    <Input name={`${pulley.id}_minDiaByShapeRatio`} value={formatDisplayValue(pulley.minDiaByShapeRatio)} readOnly />
                    {/* 풀리 직경 선택 */}
                    {isDrive ? 
                        <Input name={`${pulley.id}_diaSelected`} value={pulley.diaSelected} onClick={handleEditDrivePulley} readOnly />
                        :
                        <Select name={`${pulley.id}_diaSelected`} value={pulley.diaSelected} onChange={handleDiaSelection} required>
                            <option value="" selected disabled>Select...</option>
                            {standardPulleyDia.map(item => <option value={item}>{item}</option>)}
                        </Select>
                    }
                    {isDrive ?
                        <Input name={`${pulley.id}_laggingThick`} value={pulley.laggingThick} readOnly />
                        :
                        <Input name={`${pulley.id}_laggingThick`} value={pulley.laggingThick} onChange={handleChange} />   
                    }
                        <Input name={`${pulley.id}_diaWithLagging`} value={formatDisplayValue(pulley.diaWithLagging)} readOnly />
                        <Input name={`${pulley.id}_RPM`} value={formatDisplayValue(pulley.RPM)} readOnly />
                    <Spacer />
                    <Input name={`${pulley.id}_weight`} value={formatDisplayValue(pulley.weight)} readOnly />
                    <Spacer />
                    <div>
                        <button onClick={onAddPulley}>+</button>
                        <button onClick={() => onRemovePulley(pulley.id)}>-</button>
                    </div>
                </SelectWrapper>
            )}
            
        </PulleyEditorBlock>
    );
};

export default PulleyEditor;

const PulleyEditorBlock = styled.div`
    // & + & {
        // margin-top: -0.5rem;
        // margin-left: 0.5rem;
    // }
`;

const Wrapper = styled.div`
    margin-left: 0.5rem;

`;

const SelectWrapper = styled.div`
    margin-top: -0.5rem;
    margin-left: 0.5rem;
`;

const Input = styled.input`
    display: block;
    box-sizing: border-box;
    height: 35px;
    padding: 0.5rem 0.5rem;
    border: none;
    outline: none;
    & + & {
        margin-top: 0.5rem;
    }
    font-size: 0.9rem;
    width: 120px;
    text-align: center;
    background-color: ${palette.cyan[0]};
    ${props => props.required && css`
        background-color: ${palette.yachtBlue};
        color: white;
    `}
    ${props => props.readOnly && css`
        background-color: ${palette.gray[0]};
    `}
    ${props => props.isEditable && css`
        color: orange;
        &:hover {
            cursor: pointer;
        }    
    `}
    &::placeholder {
        color: yellow;
    }
`;

const Select = styled.select`
    display: block;
    box-sizing: border-box;
    height: 35px;
    padding: 0.5rem 0.5rem;
    border: none;
    outline: none;
    margin: 0.5rem 0;
    font-size: 0.9rem;
    width: 120px;
    text-align: center;
    ${props => props.required && css`
        background-color: ${palette.yachtBlue};
        color: white;
    `}
`;

const Spacer = styled.input`
    display: block;
    box-sizing: border-box;
    height: 10px;
    border: none;
    outline: none;
    margin: 0.5rem 0;
    width: 120px;
    // background-color: yellow;

`;